module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/rectangle-7e3016a03f740dd6e780a42322cb45a1.svg";